import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import Icon from 'components/shared/Icon';
import CalendarSync from 'components/shared/Icon/icons/CalendarSync';
import UserSync from 'components/shared/Icon/icons/UserSync';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import { EBlockType, IBlock } from 'detailsv2/__blocks';

import { useBlockContext } from '../../../Block/context';
import { ISyncBtnProps } from '../types';
import styles from './index.module.css';

function SyncBtn({ icon, text, onClick }: ISyncBtnProps) {
  return (
    <button type="button" className={styles.syncBtn} onClick={onClick}>
      {text && <Text>{text}</Text>}
      {icon && <Icon component={icon} />}
    </button>
  );
}

const BUTTONS = {
  syncContacts: <SyncBtn text="Sync to Contacts" icon={UserSync} onClick={() => null} />,
  syncCalendar: <SyncBtn text="Sync to Calendar" icon={CalendarSync} onClick={() => null} />,
};

const Subtitle = () => {
  const { block, onUpdate, readonly } = useBlockContext<IBlock<EBlockType.Subtitle>>();
  const {
    data: { text, placeholder, btnType },
  } = block;

  const handleChange = (newText: string) => {
    onUpdate?.({
      ...block,
      data: {
        ...block.data,
        text: newText,
      },
    });
  };

  if (readonly && !text) return null;

  return (
    //@ts-ignore
    <FormTitle
      className={cx(styles.subtitle, 'custom-subtitle-block')}
      mainClassName={styles.mainTitle}
      //@ts-ignore
      button={BUTTONS[btnType]}
      noBorder
      withAction
    >
      <EditableText text={text} placeholder={placeholder} onChange={handleChange} isReadonly={readonly} />
    </FormTitle>
  );
};

export default Subtitle;
